import { IAddress } from './Iaddress';
import { BrandModel } from "./BrandModel";
import { ImageModel } from "./ImageModel";
import { DefaultCoupons } from './iitem';

export interface StoreModel {
	id: string;
	name: string;
	uniqueName:string;
	inceptionDate: string;
	premiumCustomersOnly?: boolean;
	isWholesaler: boolean;
	address: IAddress;
	phoneNumber: string;
	images: [{
		SHOP_DETAIL: ImageModel;
		SHOP_LISTING: ImageModel;
		original: ImageModel;
		showOnListing:boolean
	}];
	hasHomeDelivery?: boolean;
	hasBlockingFacility?: boolean;
	hasPickUp?: boolean;
	hasParking?: boolean;
	hasLift?: boolean;
	hasDisabilityAccess?: boolean;
	floor: number;
	rating: number;
	status: 'PENDING' | 'APPROVED' | 'REJECTED';
	workingHours: [{
		day: string;
		startHrs: number;
		startMins: number;
		endHrs: number;
		endMins: number;
		createdAt?: string;
		updatedAt?: string;
	}];
	createdAt: string;
	updatedAt: string;
	brand: BrandModel;
	brandId:string;
	gstNumber: string;
	description?: string
	landmark?: string;
	accessId?: {
		id: string;
		emailId: string;
		role: string;
	},
	distance?: {
		value: number;
		unit: string;
	}
	coupons: StoreCoupons[]
	review: any[]
};

export interface StoreCoupons {
	code: string,
	name: string,
	expiration: string,
	discount: discount[]
}

export interface discount {
	discountType: string,
	discountValue: string
	maxDiscountAmount: string
	minPurchaseAmount: string
}